// extracted by mini-css-extract-plugin
export var expandCollapseButton = "ExpandCollapseButton-module--expandCollapseButton--8fe45";